<template>
    <div class="wxSend wxNoscroll">
        <wxBack></wxBack>
        <h3>{{title}}</h3>
        <Row>
            <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                <Row>
                    <FormItem prop="username">
                        <Input type="text" disabled v-model="formInline.username">
                            <Icon type="ios-person-outline" slot="prepend"></Icon>
                        </Input>
                    </FormItem>
                </Row>
                <FormItem label="招待时间">
                    <Row>
                        <Col span="16">
                            <FormItem prop="meal_date">
                                <DatePicker type="date" placeholder="请选招待餐日期" v-model="formInline.meal_date"></DatePicker>
                            </FormItem>
                        </Col>
                    </Row>
                </FormItem>
                <Row>
                    <FormItem prop="shiduan">
                        <Select v-model="formInline.meal_type" size="small" style="width:100px">
                            <Option selected v-for="(item,index) in shiduanList" :value="item.key" :key="index">{{ item.value }}</Option>
                        </Select>
                    </FormItem>
                </Row>
                <Row>
                    <Form-item label="用户部门" prop="department">
                        <Select v-model="formInline.department" style="width:162px;">
                            <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                        </Select>
                    </Form-item>
                </Row>
                <Row>
                    <FormItem prop="guests_count">
                        <Input number placeholder="招待人数" type="text" v-model="formInline.guests_count"></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem prop="receive_department">
                        <Input placeholder="受招待单位" type="text" v-model="formInline.receive_department"></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem prop="receive_name">
                        <Input placeholder="受招待人" type="text" v-model="formInline.receive_name"></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem>
                        <Button type="primary" @click="edit">{{buttonV}}</Button>
                    </FormItem>
                </Row>
                <!--<div>{{showIt}}</div>-->
                <wxNav></wxNav>
            </Form>
        </Row>
    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import wxBack from "../wxBack"
    import wxNav from "../wxNav"
    export default {
        props: ["listId"],
        data () {
          return{
                ruleInline: {
                    receive_department: [
                        { required: true, message: '请填写受招待单位', trigger: 'blur' }
                    ],
                    "guests_count": [
                        { required: true, type: "number", message: '请输入正确格式', trigger: 'blur' }
                    ],
                    receive_name: [
                        { required: true, message: '请填写受招待人', trigger: 'blur' }
                    ]
                },
                showIt:{},
                formInline: {
                    username: "",
                    realname: 'test',
                    meal_date: "",
                    meal_type:"breakfast",
                    department:"",
                    receive_name:"",
                    receive_department:"",
                    guests_count : null
                },
                departmentList:[],
                username:"xianrq",
                buttonV:"确定修改",
                islock: "success",
                status:"",
                title: "修改招待信息",
                shiduanList:[
                    {
                        value : "早餐",
                        key : "breakfast"
                    },
                    {
                        value : "午餐",
                        key : "lunch"
                    },
                    {
                        value : "晚餐",
                        key : "dinner"
                    }
                ]
            }
        },
        components:{
            wxNav,
            wxBack
        },
        computed: {
		    ...mapState(["xcxId","xcxUser","xcxReal"]),
		},
        methods:{
            //获得部门信息
            getDepartmentList: function() {
                var that = this;
                let params = {};
                params.data = {}
                params.url = '/sys/department/list';
                params.token = "swgykj9527";
                params.success = function(res) {
                  res = res.data;
                  that.departmentList = res.result.result;
                  that.formInline.department = that.departmentList[0].name;
                }
                this.ajaxPostWX(params);
            },
            //获得该信息
            getInfo() {
                var that = this;
                let params = {};
                params.data = {
                    searchValue: {
                        "id": this.listId
                    },
                }
                params.url = '/sys/mealentertain/list';
                params.token = "swgykj9527";
                params.success = function(res) {
                  that.formInline = res.data.result.result[0]
                }
                this.ajaxPostWX(params);
            },
            edit() {
                var that = this;
                let params = {};
                params.data = that.formInline;
                params.data.meal_date = params.data.meal_date.format("yyyy-MM-dd");
                params.url = '/sys/mealentertain/edit';
                params.token = "swgykj9527";
                params.success = function(res) {
                    if(res.data.code == "0000"){
                        that.$Message.success(res.data.message);
                        that.$router.push("/data/wxEnterList/"+window.localStorage.getItem("wxCode"));
                    }else{
                        that.$Message.error(res.data.message);
                    }
                }
                this.ajaxPostWX(params);
            }
        },
        mounted: function() {
            this.getDepartmentList();
            this.getInfo();
        }
    }
</script>

<style lang="scss">
    .wxSend{
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxEditEnter.vue